import React from 'react'
import * as classes from './iframe.module.scss'

export default function Thumbnail(props) {
  return (
    <div style={{ height: props.height ? props.height : '600px' }} className={"col-12 mb-3 " + classes.IframeWrapper}>

      <iframe
        title={props.title}
        className={classes.Iframe}
        src={props.src}
        frameBorder="0"
        allowFullScreen="allowfullscreen"></iframe>

    </div>
  )
}

